import { cn } from '@shared/lib/cn';

export interface SwitchSkeletonProps {
  className?: string;
}

/** Switch 의 status=init — 트랙 40×24 + 글자 막대 80×12 */
export function SwitchSkeleton({ className }: SwitchSkeletonProps) {
  return (
    <span
      aria-hidden="true"
      data-status="init"
      className={cn('skeleton-pulse', 'inline-flex items-center gap-2-5', className)}
    >
      <span className="h-6 w-10 rounded-full bg-bg-pressed" />
      <span className="h-3 w-20 rounded-full bg-bg-pressed" />
    </span>
  );
}
